import { connect } from 'react-redux'
import { crudListStyle } from '../../styles'
import { ratingsActions, searchTableActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CrudHeader from '../../components/CrudHeader'
import Layout from '../../components/Layout'
import ListTable from './ListTable'
import React, { Component } from 'react'
import UserToolbar from '../../components/UserToolbar'
import { withRouter } from 'react-router-dom'
import FilterSelect from '../../components/FilterSelect'
import { ratings } from '../../api'
class Ratings extends Component {
  componentWillMount() {
    const { changeTerm } = this.props
    const { term } = this.props.location.state || {}

    if (term) changeTerm(term)
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { classes, token } = this.props

    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Avaliações'}
          classes={classes}
          token={token}
          functionality={'conteudos'}
          displayCreateButton={false}
        >
          <FilterSelect
            placeholder="Selecione um status..."
            loadOptions={ratings.getSelectStatus}
          />
        </CrudHeader>
        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetState: () => {
      dispatch(ratingsActions.resetState())
    },
    changeTerm: term => {
      dispatch(searchTableActions.changeTerm(term))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(crudListStyle)(Ratings)))



// WEBPACK FOOTER //
// ./src/containers/Ratings/index.js